export const joannaWisniewska = {
    'meta': {
        'title': 'Psychoterapeuta młodzieży i dorosłych Joanna Wiśniewska',
        'description': 'Psycholog wojskowy, psychotraumatolog, psychoterapeuta psychodynamiczny w trakcie specjalistycznego, członek Polskiego Towarzystwa Psychotraumatologii.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-joanna-wisniewska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/joanna-wisniewska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu, Psychoterapeuta w Toruniu Joanna Wiśniewska'
        }
    }
}